// extracted by mini-css-extract-plugin
export default {"indicatorBox":"QuartelyDeltaIndicators__indicatorBox","quarterArrow":"QuartelyDeltaIndicators__quarterArrow"};